import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path, pathOr } from 'ramda';
import { withAsyncActions, withSagas, toSuccess } from 'react-async-client';
import Translate from 'react-translate-component';
import { Button } from 'antd';
import { takeEvery } from 'redux-saga/effects';

import { notEmpty } from 'utils/ramdaAdditions';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { fullAutoOptions } from 'constants/asyncClient';
import { getNotdoneList, updateEvent } from 'actions/asyncActions';
import { openModalEvent } from 'actions/modalActions';
import getNotdoneTableTemplates from './cellTemplates/notdoneTableTemplates';
import List from 'components/common/List';
import RefreshButton from 'components/common/controls/RefreshButton';
import { setNotdoneListSort, setNotdoneListPagination } from 'actions/notdoneActions';
import CustomIcon from 'components/common/CustomIcon';

const defaultColumns = [
    {
        name: 'checkbox',
        width: 60,
    },
    {
        name: 'number',
        width: 40,
    },
    {
        name: 'date',
        width: 100,
        keySort: 'date',
    },
    {
        name: 'time',
        width: 100,
    },
    {
        name: 'name',
        width: 'auto',
    },
    {
        name: 'projects',
        width: 250,
    },
    {
        name: 'people',
        width: 250,
    },
    {
        name: 'contact',
        width: 250,
    },
    {
        name: 'organizations',
        width: 250
    }
];

const tableConfig = {
    defaultColumns,
    getTemplate: getNotdoneTableTemplates,
    headerTranslatePrefix: 'notdone.headers.',
};

const dispatchToProps = {
    setSort: setNotdoneListSort,
    setPagination: setNotdoneListPagination,
    openModalEvent,
};

@connect(path(['table', 'notdone']), dispatchToProps)
@withAsyncActions({
    getNotdoneList: getNotdoneList.withOptions(fullAutoOptions)
})
@withSagas([function* (getProps) {
    yield takeEvery([toSuccess(updateEvent.type)], () => {
        const props = getProps();
        props.getNotdoneList.refresh();
    });
}])
@withRouteOptions
export default class NotdoneListView extends Component {
    static routeOptions = {
        title: 'menu.notdone'
    }

    openEvent = () => {
        const { selected, getNotdoneList } = this.props;
        const event = path(['contacts', selected], getNotdoneList.data);

        if (event) {
            this.props.openModalEvent({
                id: event.id,
                value: event.name,
                initialEnterResultState: true
            });
        }
    }

    renderControls = ({ handleRefresh }) => {
        const { selected } = this.props;
        const { meta } = this.props.getNotdoneList;

        return (
            <div>
                <Button disabled={!notEmpty(selected)} onClick={this.openEvent}>
                    <CustomIcon type="calendar-plus" />
                    <Translate content='events.enterResult' />
                </Button>
                <span className="icon-bar">
                    <RefreshButton refreshMeta={meta} handleRefresh={handleRefresh} />
                </span>
            </div>
        );
    }

    render() {
        const { getNotdoneList, getNotdoneList: { data, meta } } = this.props;
        const items = pathOr([], ['contacts'], data);

        return (
            <List
                className='width-auto-table'
                getList={getNotdoneList}
                items={items}
                meta={meta}
                tableConfig={tableConfig}
                controls={this.renderControls}

                {...this.props}
            />
        );
    }
}
